import React, { useState , useEffect } from "react";
import { calender, logo } from "../../images";
import styles from "./Header.module.css";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdClose } from "react-icons/md";
import { connectWallet } from "../contracts/account";
export const trunc = (
  _ = "0x0000000000000000000000000000000000000000",
  start = 6,
  end = 4
) =>
  _ ? _.slice(0, start) + ".." + _.slice(_.length - end, _.length) : "0x..00";
  

  

const Header = () => {

  const [sidebar, setSidebar] = useState(false);
  const navArray = [

  ];
  return (
    <section className={styles.header}>
      <Link to="/" className={styles.logoWrapper}>
        <div className={styles.logoContainer}>
          <img src={`https://fierypace.com/logo.svg`} alt="Logo" className={styles.logo} />
          <h5 className={styles.logoText}></h5>
        </div>
      </Link>
      {sidebar ? (
        <MdClose
          className={styles.icon}
          onClick={() => setSidebar((prev) => !prev)}
        />
      ) : (
        <GiHamburgerMenu
          className={styles.icon}
          onClick={() => setSidebar((prev) => !prev)}
        />
      )}
      <div className={styles.navBar}>
        {navArray.map((item, index) => (
          <Link href={item.to} key={index} className={styles.navLink}>
            {item.navItem}
          </Link>
        ))}
        <div className={styles.calender}>
          <img
            src={calender}
            alt="calendder"
            className={styles.calenderImage}
          />
          <p className={styles.calenderText}></p>
        </div>
      </div>
      {sidebar && (
        <div className={styles.sidebar}>
          {navArray.map((item, index) => (
            <Link href={item.to} key={index} className={styles.navLink}>
              {item.navItem}
            </Link>
          ))}
          <div className={styles.calender}>
            <img
              src={calender}
              alt="calendder"
              className={styles.calenderImage}
            />
            <p className={styles.calenderText}></p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Header;
